import { openItemPeekInternal } from './openItemPeekInternal';
import { openItemPeekToRespond } from '../actions/itemPeekActions';
import { closeItemPeek } from '../actions/closeItemPeek';
import { respondToCalendarEvent } from 'owa-calendar-events-actions';
import type CalendarTime from 'owa-calendar-types/lib/types/CalendarTime';
import { ControlIcons } from 'owa-control-icons';
import type AttendeeType from 'owa-service/lib/contract/AttendeeType';
import EventScope from 'owa-service/lib/contract/EventScope';
import { shouldShowDeclinedEvents } from 'owa-show-declined-meetings-user-config';
import { orchestrator } from 'satcheljs';
import EditorScenarios from 'owa-editor/lib/store/schema/EditorScenarios';

/**
 * Opens the item peek with the RSVP dialog already expanded
 * @calendarEventId item id of the event being responded to
 * @eventScope eventScope that respond is performed on
 * @responseType Type of response or 'Cancel' if it is cancel scenario
 * @titleText The text of the title on the notes editor
 */
orchestrator(openItemPeekToRespond, actionMessage => {
    let {
        calendarEvent,
        eventScope,
        titleText,
        actionSource,
        responseType: selectedResponseType,
    } = actionMessage;
    const iconDict = {
        Accept: ControlIcons.Accept,
        Tentative: ControlIcons.Help,
        Decline: ControlIcons.Cancel,
    };
    const onSend = (
        eventScope: EventScope,
        notes: string,
        proposeNewTime: CalendarTime,
        sendResponse: boolean,
        forwardees: AttendeeType[],
        timeOpen: number
    ) => {
        respondToCalendarEvent(
            calendarEvent.ItemId,
            calendarEvent.ResponseType,
            selectedResponseType,
            calendarEvent.FreeBusyType,
            eventScope,
            sendResponse,
            actionSource,
            notes,
            proposeNewTime,
            shouldShowDeclinedEvents()
        );
        closeItemPeek();
    };
    openItemPeekInternal(calendarEvent, {
        editorScenario: EditorScenarios.ItemPeekToRespond,
        eventScope: eventScope,
        onSend: onSend,
        titleText: titleText,
        iconName: iconDict[selectedResponseType] || ControlIcons.CalendarReply,
        showNotifyToggle: calendarEvent.IsResponseRequested,
        sendResponse: calendarEvent.IsResponseRequested,
        isDeclinedSeriesInstance:
            calendarEvent.ResponseType === 'Decline' &&
            calendarEvent.IsRecurring &&
            eventScope !== EventScope.AllInstancesInSeries,
    });
});
